import { render, staticRenderFns } from "./JournalItems.vue?vue&type=template&id=296a24a0&scoped=true"
import script from "./JournalItems.vue?vue&type=script&lang=js"
export * from "./JournalItems.vue?vue&type=script&lang=js"
import style0 from "./JournalItems.vue?vue&type=style&index=0&id=296a24a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296a24a0",
  null
  
)

export default component.exports